module.exports = __webpack_public_path__ + "static/media/Other.1ddf6dc9.svg";